// import React, { useState } from 'react';
import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Outlet } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toolbar from 'src/layouts/DashboardLayout/Toolbar';
import NavBar from './NavBar';
import { addTemplates } from '../../redux/reducers/templates/actions';
import TemplateApi from '../../utils/apiManager/constrollers/templateApi';
import GroupApi from '../../utils/apiManager/constrollers/groupApi';
import { addGroups } from '../../redux/reducers/groups/actions';
import { getAlerts } from '../../redux/reducers/alerts/selectors';
import { showError } from '../../redux/reducers/alerts/actions';
import { updateUser } from '../../redux/reducers/user/actions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    width: '100%',
    // padding: '15px 25px 25px 50px'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    paddingTop: 0,
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    flexFlow: 'column',
  },
  content: {
    flex: '1 1 auto',
    justifyContent: 'flex-left',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  navBar: {
    display: 'flex'
  },
  navAndOutlet: {
    display: 'flex',
    flexFlow: 'row',
    flex: '1 1 auto',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexFlow: 'column',
    }
  }
});

class DashboardLayout extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  async componentDidMount() {
    this.templateApi = await TemplateApi.getInstance();
    const templates = await this.templateApi.fetchTemplates();
    if (templates) {
      this.props.addTemplates(templates);
    }

    const groupApi = await GroupApi.getInstance();

    const fetchedGroups = await groupApi.fetchGroups();
    if (fetchedGroups) {
      this.props.addGroups(fetchedGroups);
    }
  }

  handleClose() {
    this.props.showError(false);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        {/* <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} /> */}
        {/* <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      /> */}
        <Snackbar open={this.props.show} autoHideDuration={3000} onClose={this.handleClose}>
          <Alert onClose={this.handleClose} severity="error">
            {this.props.errorMessage}
          </Alert>
        </Snackbar>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div>
              <Toolbar />
            </div>
            <div className={classes.navAndOutlet}>
              <div>
                <NavBar />
              </div>
              <div className={classes.content}>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  addTemplates: PropTypes.func,
};

export default connect(
  getAlerts,
  {
    addTemplates,
    showError,
    addGroups,
    updateUser,
  },
)(withStyles(styles)(DashboardLayout));
